if (document.querySelectorAll('.image-section').length) {
    document.querySelectorAll('.image-section').forEach(section => {
        const images = section.querySelectorAll('.all-slide');
        console.log(images);
        images.forEach(image => {
            image.addEventListener('click', function () {
                var data_index = this.getAttribute("data-index");
                const allImages = document.querySelectorAll('.all-slide');
                console.log(allImages);
                if (document.querySelector('.main-slider') && !document.querySelector('.main-slider').classList.contains('swiper-initialized')) {
                    allImages.forEach(image => {
                        const slide = document.createElement('div');
                        slide.classList.add('swiper-slide');
                        slide.append(image.cloneNode(true));
                        document.querySelector('.main-slider').querySelector('.swiper-wrapper').append(slide);
                    })
                    //Slider
                    window.mainSwiper = new Swiper('.swiper', {
                        // Optional parameters
                        loop: true,
                        // If we need pagination
                        pagination: {
                            el: '.swiper-pagination',
                        },

                        // Navigation arrows
                        navigation: {
                            nextEl: '.swiper-button-next',
                            prevEl: '.swiper-button-prev',
                        },
                    });

                    var mainindex = 0;

                    document.querySelectorAll(".main-slider .swiper-slide").forEach(function (slide, index) {
                        if (slide.getAttribute("data-swiper-slide-index") == data_index) {
                            mainindex = index;
                        }
                    })

                    document.querySelector('.main-slider-container').addEventListener('click', function () {
                        this.classList.remove('active');
                    })
                    document.querySelector('.main-slider').addEventListener('click', function (e) {
                        e.stopPropagation();
                    })
                    document.querySelector('.main-slider-container').classList.add('active');


                    if (data_index == 0) {
                        // window.mainSwiper.slideTo(1);
                        // window.mainSwiper.slideTo(0);
                        // window.mainSwiper.slideTo(-1);
                    }
                    else {
                        window.mainSwiper.slideTo(mainindex);
                    }
                } else {
                    document.querySelector('.main-slider-container').classList.add('active');
                    var mainindex = 0;

                    document.querySelectorAll(".main-slider .swiper-slide").forEach(function (slide, index) {
                        if (slide.getAttribute("data-swiper-slide-index") == data_index) {
                            mainindex = index;
                        }
                    })

                    if (mainindex == 0) {
                        window.mainSwiper.slideTo(1);
                        window.mainSwiper.slideTo(0);
                        window.mainSwiper.slideTo(-1);
                    }
                    else {

                        window.mainSwiper.slideTo(mainindex);
                    }
                }
            })
        })
    })
}